import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "container mx-auto px-4 py-28"
}
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 mb-4 text-center text-2xl font-bold" }, [
  /*#__PURE__*/_createTextVNode(" Congratulations, your account has been"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" successfully created! ")
], -1)
const _hoisted_5 = { class: "my-1 text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_7 = { class: "text-black" }
const _hoisted_8 = { class: "my-1 text-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Account/Wallet address : ")
const _hoisted_10 = { class: "my-6 flex justify-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Back to Home ")
const _hoisted_13 = {
  key: 1,
  class: "max-w-fit mx-autor px-4 py-28"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-center font-semibold text-2xl mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Please confirm that you would like to receive the NFTs"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "in the following account.")
], -1)
const _hoisted_15 = { class: "text-center text-xl mb-3" }
const _hoisted_16 = { class: "text-center mb-6" }
const _hoisted_17 = { class: "my-6 flex justify-center w-full mb-6" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Receive ")

import { defineComponent, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as api from '@/apis';
import IconSignupSuccess from '@/components/Icons/IconSignupSuccess.vue';
import { useUserStore } from '@/store/user';
import useReceive from '@/composables/useReceive';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const { receive } = useReceive();

defineComponent({
  name: 'ReceiveBySignUpView',
});

const route = useRoute();
const router = useRouter();
const email = computed(() => localStorage.getItem('receive_email'));

const isReceiveSignup = computed(() => {
  return route.name === 'ReceiveBySignUp';
});

const nextStep = () => {
  router.push(`/landing/receive/${route.params.id}/login`);
};

const sendAnother = () => {
  router.push(`/landing/send-nft/${route.params.id}`);
};

const goBack = () => {
  router.push(`/landing/`);
};

const confirmReceive = async () => {
  const channel = localStorage.getItem('receive_channel');

  const paramReceive = {
    paymentId: localStorage.getItem('receive_id') as string,
    recipient: userStore.me?.attributes.ethAddress,
  };
  if (channel === '2') {
    await api.receiveSendByGuest(paramReceive);
    router.push(`/landing/send-nft/${paramReceive.recipient}/confirm`);
  } else {
    receive(userStore.me?.attributes.ethAddress);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isReceiveSignup))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(IconSignupSuccess)
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(userStore).attributes.email), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_unref(userStore).attributes.ethAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_unref(isReceiveSignup))
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  "color-scheme": "primary",
                  height: "40px",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (nextStep()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/landing"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseButton, {
                      "color-scheme": "primary",
                      height: "40px",
                      "data-testid": "receive-signup-home"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(email)), 1),
          _createElementVNode("div", _hoisted_16, " Account/Wallet address : " + _toDisplayString(_unref(userStore).attributes.ethAddress), 1),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_BaseButton, {
              class: "w-full",
              "color-scheme": "primary",
              height: "40px",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmReceive())),
              "data-testid": "receive-signup-confirm-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "text-center text-sm font-medium mb-6 cursor-pointer text-primary-dark",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (goBack())),
            "data-testid": "receive-signup-back-btn"
          }, " No, I would not like to receive the NFTs anymore. "),
          _createElementVNode("div", {
            class: "text-center font-bold cursor-pointer text-primary-dark",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (sendAnother())),
            "data-testid": "receive-signup-another"
          }, " Send to another wallet ")
        ]))
  ]))
}
}

})